export interface Destination {
  href: string;
  enabled: boolean;
}

function destination(href: string): Destination {
  return { href, enabled: href !== "" };
}

export const links = {
  video: destination("https://youtu.be/wR2uA0lUD_M"),
  brochure: destination("https://adbond.sa/wp-content/uploads/2026/10/Qurtuba-Facade-Brochure.pdf"),
  map: destination("https://maps.app.goo.gl/Df2ed7GLLM6zFTZLA"),
  whatsapp: destination("https://wa.me/message/MSCA4D3CO775J1"),
};

export function platformDestination(locale: "ar" | "en"): Destination {
  return destination(
    `https://tdco-interactive-map.pages.dev/?lang=${locale}&view=riyadh&project=2&iv=2`,
  );
}
